/**
 * Shared UI component for UI Toast Outlet.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { UiToastComponent } from './ui-toast.component';
import { UiToastService } from './ui-toast.service';

@Component({
  selector: 'ui-toast-outlet',
  standalone: true,
  imports: [UiToastComponent],
  template: `
    <ui-toast
      [visible]="!!toastService.toast()"
      [type]="toastService.toast()?.type ?? 'info'"
      [title]="toastService.toast()?.title ?? ''"
      [message]="toastService.toast()?.message ?? ''"
      [durationMs]="toastService.toast()?.durationMs ?? 3000"
      (dismiss)="toastService.dismiss()"
    ></ui-toast>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiToastOutletComponent {
  protected readonly toastService = inject(UiToastService);
}
